module.exports = __webpack_public_path__ + "static/media/orange-tick.7309a4d9.svg";